import React, { useMemo } from 'react';
// import { SquareButton } from '../../../Core/FormInput/AppButton';
import { Button, Grid, IconButton, Tooltip, Typography } from '@material-ui/core';
import ReactDOM from 'react-dom';
import { useState } from 'react';
import formatters from '../../../../Core/Grid/inputFormatter';
import { BasicButtonGroup } from '../../../../Core/ButtonGroup';
import { getWorkflowsByProcessID } from '../../../../Core/Service/workflow-service';
import { useEffect } from 'react';
import NestedGijgoGrid from './nestedGijgoGrid';
import './usedSalesStyle.scss';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import AddIcon from '@material-ui/icons/Add';
import { useHistory } from 'react-router-dom';
import DialogComp from '../../../../Core/Modal/dialogModal';
import JobAssignedUser from './WorkFlow/JobAssignedUser';
import JobNotesModal from './WorkFlow/JobNotes';
import PeopleIcon from '@material-ui/icons/People';
import { PermMedia, Refresh, SpeakerNotes } from '@material-ui/icons';
import { useWindowSize } from '../../../../Core/Controls/ScreenResolution';

const baseColumns = [
    { field: 'action', sortable: false, title: `Action`, width: 100 },
    { field: 'vsb', sortable: false, title: `Stock No`, width: 70 },
    { title: 'Reg No', field: 'reg', width: 120, sortable: true },
    { title: 'Vehicle Description', field: 'vd', width: 200, sortable: true },
    { title: 'Model', field: 'model', width: 90, sortable: true },
    { title: 'Customer', field: 'cust', width: 280, sortable: true },
    { title: 'Gross Profit', field: 'gp', width: 140, sortable: true, renderer: formatters.CurrencyThousandSeparator },
    { title: 'Sold By', field: 'sp', width: 200, sortable: true },
    { title: 'Assigned', field: 'assignedUser', width: 200, sortable: true },
    {
        title: 'Return Reason',
        field: 'rr',
        width: 200,
        sortable: true
    }
];

const detailTemplate = () => {
    return `<div style='width:100%'>
        <table style='width:100%;'>
            <tr style='background-color:#DCDCDC;' >
                
                <th style='font-weight:750; text-align:left;'></th>
                <th style='font-weight:750; text-align:left;'>Order No</th>
                <th style='font-weight:750; text-align:left;'>Sale Price</th>
                <th style='font-weight:750; text-align:left;'>Cost Price</th>
                <th style='font-weight:750; text-align:left;'>Disc O/A</th>
                <th style='font-weight:750; text-align:left;'>Bonuses</th>
                <th style='font-weight:750; text-align:left;'>Subsidy</th>
                <th style='font-weight:750; text-align:left;'>CPI</th>
                <th style='font-weight:750; text-align:left;'>Finance</th>
                <th style='font-weight:750; text-align:left;'>PDI</th>
                <th style=' font-weight:750; text-align:left;'>DFA Sale</th>
                <th style='text-align:left;font-weight:750;'>DFA Cost</th>
                <th style='text-align:left;font-weight:750;'>Intro Comm</th>
                <th style='width:20%; font-weight:750; text-align:left;'>Finance Company</th>
                <th style='font-weight:750; text-align:left;'>Shipment Number</th>
            </tr>
            <tr>
                
                <td></td>
                <td>{ord}</td>
                <td>£{sale}</td>
                <td>£{cost}</td>
                <td>£{discOval}</td>
                <td>£{bonuses}</td>
                <td>£{subsidy}</td>
                <td>£{cpi}</td>
                <td>£{finance}</td>
                <td>£{pdi}</td>
                <td>£{dfaSale}</td>
                <td>£{dfaCost}</td>
                <td>£{introCom}</td>
                <td>{fcompany}</td>
                <td>{ship}</td>
            </tr>
        </table>
        </div>`;
};

const UsedSalesListView = (props) => {
    const [windowWidth, windowHeight] = useWindowSize();
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const ParamWorkFlowId = params.get('workFlowId');
    const ParamProcessId = params.get('ProcessId');
    const history = useHistory();

    const [state, setState] = useState({
        showModal: false,
        processId: ParamProcessId || props.ProcessId || 4,
        currentWorkflowId: ParamWorkFlowId || localStorage.getItem('currentUsedWorkflowId'),
        timeID: JSON.parse(localStorage.getItem('UsedSalesDashParams'))?.branchTime || '',
        dueTime: JSON.parse(localStorage.getItem('UsedSalesDashParams'))?.dueTime || ''
    });

    const handleSearchStock = async (vsb, apprisalId) => {
        const searchQuery = `?appraisalId=${apprisalId ? apprisalId : ''}&Vehid=${''}&stockId=${vsb}`;
        history.push({
            pathname: `/Appraisal_createAppraisal`,
            search: searchQuery
        });
    };

    const handleAssignUser = (record) => {
        setState((st) => ({
            ...st,
            showJobAssignedUser: true,
            selectedStockID: record.usedStockID,
            jobId: record.jobId
        }));
    };

    const handleJobNotes = (val, on) => {
        setState((st) => ({
            ...st,
            jobNotes: on,
            selectedStockID: val.usedStockID,
            reg: val.reg,
            vsb: val.vsb
        }));
    };

    const randerAction = (value, record) => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid container justifyContent="space-between">
                <Grid item style={{ cursor: 'pointer' }}>
                    <Tooltip title={record.appraisalId ? 'Edit Appraisal' : 'Create Appraisal'}>
                        <IconButton size="small" onClick={() => handleSearchStock(record.vsb, record.appraisalId)}>
                            {record.appraisalId ? <EditOutlinedIcon fontSize="small" color="primary" /> : <AddIcon fontSize="small" color="primary" />}
                        </IconButton>
                    </Tooltip>
                </Grid>
                <Grid item style={{ cursor: 'pointer' }}>
                    <Tooltip title="Assign User">
                        <IconButton size="small" onClick={() => handleAssignUser(record)}>
                            <PeopleIcon size="small" style={{ color: record.assignedUser ? 'green' : record.returnReasonTextColourCode }} />
                        </IconButton>
                    </Tooltip>
                </Grid>
                <Grid item style={{ cursor: 'pointer' }}>
                    <Tooltip title="Job Notes">
                        <IconButton size="small" onClick={() => handleJobNotes(record, true)}>
                            <SpeakerNotes style={{ color: record.hasNote ? 'gold' : record.returnReasonTextColourCode }} fontSize="small" />
                        </IconButton>
                    </Tooltip>
                </Grid>
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const column = useMemo(() => {
        let col = [...baseColumns];
        col = col.map((p) => {
            if (p.field != 'action') {
                p.events = {
                    click: function (e) {
                        props.history.push(`/UsedJob/${e.data.record.usedStockID}/${state.currentWorkflowId}?ProcessId=${state.processId}`);
                    }
                };
            }
            return { ...p };
        });

        let isActionCol = col.find((element) => element.field === 'action');
        if (isActionCol) {
            isActionCol.renderer = randerAction;
        }
        return col;
    }, [state.currentWorkflowId]);

    const buttonClicked = async (btn) => {
        localStorage.setItem('currentUsedWorkflowId', btn.id);
        setState((st) => {
            const newSt = { ...st };
            if (!newSt.hasQueryValues) {
                newSt.returnReasonID = '';
            } else {
                newSt.hasQueryValues = false;
            }
            newSt.currentWorkflowId = `${btn.id}`;
            newSt.currentWorkflowLabel = btn.label;

            return newSt;
        });
    };

    const pullWorkFlowsButtons = async () => {
        let res = await getWorkflowsByProcessID(state.processId);
        if (res.success) {
            const buttons = res.data.map((w) => ({
                id: w.id,
                label: w.workflowName,
                displayJobPriorityButton: w.displayJobPriorityButton == 'Y' ? true : false,
                displayCustomerRatingButton: w.displayCustomerRatingButton == 'Y' ? true : false
            }));

            setState((st) => ({ ...st, workflowButtons: buttons }));
        }
    };

    useEffect(() => {
        pullWorkFlowsButtons();
    }, []);

    useEffect(() => {
        const baseUrl = `UsedVehicleDashboard/List/${state.currentWorkflowId == 'All' ? '' : state.currentWorkflowId}?${
            state.timeID ? `&Time=${state.timeID}` : ''
        }${state.dueTime ? `&dueTime=${state.dueTime}` : ''}`;
        setState((st) => ({ ...st, baseUrl: baseUrl }));
    }, [state.currentWorkflowId]);

    const onJobAssignedUserClick = () => {
        setState((st) => ({
            ...st,
            showJobAssignedUser: true
        }));
    };

    const onJobAssignedUserClose = () => {
        setState((st) => ({
            ...st,
            showJobAssignedUser: false,
            selectedStockID: ''
        }));
    };

    const modalSubHeaderTitle = () => {
        return (
            <div>
                <span style={{ fontSize: '15px' }}>
                    Stock No: <b>{state.vsb}</b> Reg No: <b>{state.reg}</b>
                </span>
            </div>
        );
    };
    const rowDataStyle = (record) => ({
        'background-color': record.rrColourcode || 'white'
    });

    const colDataStyle = (record) => ({
        color: record.txtColourCode || 'black'
    });

    return (
        <div className="useSalesGrid">
            <Grid container justifyContent="space-between" alignItems="center">
                <Grid item xs>
                    <BasicButtonGroup
                        margin={6}
                        buttons={state.workflowButtons}
                        onClick={buttonClicked}
                        btnSelectedId={state.currentWorkflowId || null}
                        className="left-align-buttons"
                        allGrid={true}
                    />
                </Grid>
            </Grid>
            <NestedGijgoGrid
                dataConverter={(res) => ({
                    records: res?.data?.list,
                    total: res?.data?.total
                })}
                columns={column}
                getUrl={state.baseUrl}
                displayPagination={true}
                isReload={state.isReload}
                detailTemplate={detailTemplate}
                setRowStyleOnCondition={true}
                setRowStyleFunction={rowDataStyle}
                setColStyleOnCondition={true}
                setColStyleFunction={colDataStyle}
            />

            {state.showJobAssignedUser && (
                <DialogComp
                    title={`Assigned User - ${state.selectedStockID}`}
                    onClose={onJobAssignedUserClose}
                    fullWidth
                    fullScreen={windowWidth <= 1280 ? true : false}
                    maxWidth="md"
                    overflow="auto"
                >
                    <JobAssignedUser stockID={state.selectedStockID} onClose={onJobAssignedUserClose} />
                </DialogComp>
            )}
            {state.jobNotes ? (
                <JobNotesModal
                    modalSubHeaderTitle={modalSubHeaderTitle}
                    maxWidth="md"
                    stockID={state.selectedStockID}
                    onClose={() => handleJobNotes([], false)}
                    onNotesAdded={() => {
                        console.log('');
                    }}
                />
            ) : null}
        </div>
    );
};

export default UsedSalesListView;
